module.exports = __webpack_public_path__ + "static/media/sidebar_bg.fa905a42.png";